import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { pull } from 'lodash';
import { ButtonAction, ButtonType } from '../../../ui-kit';
import { UserItemFacade, UserRolesModel, UserRoleType } from '../../../store';
import { Role } from '../../../common';

@Component({
  selector: 'lib-roles-selection-dialog',
  templateUrl: './role-selection-dialog.component.html',
  styleUrls: ['./role-selection-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RolesSelectionDialogComponent implements OnInit {
  allRolesControl = new FormControl<UserRolesModel | Role[]>([], [Validators.required]);
  buttonAction = ButtonAction;
  buttonType = ButtonType;

  constructor(
    public userItemFacade: UserItemFacade,
    public dialogRef: MatDialogRef<RolesSelectionDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public assignedRoles: UserRolesModel,
  ) {}

  ngOnInit(): void {
    Object.keys(this.assignedRoles).forEach((group: UserRoleType) =>
      this.assignedRoles[group].forEach((role: Role) => this.changeCheckbox(group, true, role)),
    );
  }

  changeCheckbox(parentKey: UserRoleType | string, checked: boolean, value: string): void {
    const allRolesPreviousValue: UserRolesModel | Role[] = this.allRolesControl.value;
    const parentRolesGroupValue: Role[] = allRolesPreviousValue[parentKey] || [];

    checked
      ? this.allRolesControl.setValue({
          ...allRolesPreviousValue,
          [parentKey]: [...parentRolesGroupValue, value],
        })
      : this.allRolesControl.setValue({
          ...allRolesPreviousValue,
          [parentKey]: pull(parentRolesGroupValue, value),
        });
  }

  isRoleChecked(role: Role, parentKey: UserRoleType | string): boolean {
    return (
      [].concat(...Object.values(this.assignedRoles)).some((item: Role) => item === role) &&
      parentKey in this.assignedRoles
    );
  }

  confirm(): void {
    this.dialogRef.close(this.allRolesControl.value);
  }

  closeDialog(): void {
    this.dialogRef.close();
  }
}
